import { Tag } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { billStatusToTagColor } from '@features/bills/constants/billStatusToTagColor'
import { billStatusToTitleKey } from '@features/bills/constants/billStatusToTitleKey'
import { BillStatus } from '@features/bills/enums/billStatus'

interface BillPaymentPanePrefixProps {
  status: BillStatus
}

export const BillPaymentPanePrefix = ({ status }: BillPaymentPanePrefixProps): ReactElement => {
  const { t } = useTranslation()

  const tagColor = billStatusToTagColor[status]
  const tagLabel = t(billStatusToTitleKey[status])

  return (
    <Tag color={tagColor} type="subtle">
      {tagLabel}
    </Tag>
  )
}
